'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function CarouselProgress({
  selectedIndex,
  totalSlides,
}: {
  selectedIndex: number;
  totalSlides: number;
}) {
  return (
    <div className="flex h-[4px] w-full items-center justify-start rounded-full bg-border">
      <div
        className={cn('h-[4px] rounded-full bg-black transition-all ease-in-out')}
        style={{ width: `${((selectedIndex + 1) / (totalSlides || 1)) * 100}%` }}
      />
    </div>
  );
}
